import * as React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import { Box, Divider, Fab, Zoom } from "@mui/material/";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Experiences from "./components/Experiences";
import Skills from "./components/Skills";
import Footer from "./components/Footer";
import Theme from "./Theme";

export default function App() {
  const [mode, setMode] = React.useState("dark");
  const [showFab, setShowFab] = React.useState(false);
  const LPtheme = createTheme(Theme(mode));

  const toggleColorMode = () => {
    setMode((prev) => (prev === "dark" ? "light" : "dark"));
  };

  React.useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 300;
      setShowFab(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <Navbar mode={mode} toggleColorMode={toggleColorMode} />
      <Home />
      <Box sx={{ bgcolor: "background.default" }}>
        <Divider />
        <Experiences />
        <Divider />
        <Skills />
        <Divider />
        <Projects />
        <Divider />
        <Footer />
      </Box>
      <Zoom in={showFab}>
        <Fab
          size="medium"
          color="primary"
          sx={{ position: "fixed", bottom: 90, right: 24}}
          onClick={scrollToTop}
        >
          <ArrowDropUpIcon />
        </Fab>
      </Zoom>
    </ThemeProvider>
  );
}
